import "./page-forest-monitoring.scss";
import "../../js/core";
import "../../components/site-elements/other-blocks/collapse-content-list/collapse-content-list";
import { SwiperInit } from "../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs";

SwiperInit("swiper-1");

import(
  /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
).then(() => {
  import(
    /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
  ).then(() => {
    $(".slider-card-blog").owlCarousel({
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        992: {
          items: 3,
        },
      },
      loop: false,
      nav: true,
      dots: false,
      slideBy: 1,
      margin: 20,
      smartSpeed: 200,
    });

    $(".owl-carousel").each(function (index) {
      $(this)
        .find(".owl-nav, .owl-dots")
        .wrapAll("<div class='owl-controls'></div>");
    });
  });
});
